export default __webpack_public_path__ + "static/media/Portrait_Solid.1770e24e.svg";